import { $themeConfig } from '@themeConfig'
import AccountsService from '@/api/client/accounts.service'

export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: $themeConfig.layout.menu.isCollapsed,
    account: {},
    load: false,
    isInAdminPlatform: false,
    changedBreadcrumbs: null,
  },
  getters: {
    accountContext: state => state.account,
    loading: state => state.load,
    adminPlatform: state => state.isInAdminPlatform,
    changedBreadcrumbs: state => state.changedBreadcrumbs,
  },
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val
    },
    setAccountContext(state, accountContext) {
      state.account = accountContext
    },
    setLoading(state, isLoading) {
      state.load = isLoading
    },
    changePlatform(state, value) {
      state.isInAdminPlatform = value
    },
    changeBreadcrumbs(state, value) {
      state.changedBreadcrumbs = value
    },
  },
  actions: {
    async changeAccountContext({ commit, state }, accountId) {
      try {
        if (state.account.id === accountId) { return }
        const response = await AccountsService.getAccount(accountId)
        if (response && response.accountId) {
          commit('setAccountContext', response)
        }
      } catch (error) {
        this.error(error.message)
      }
    },
    async getDefaultAccount({ commit }) {
      try {
        const response = await AccountsService.getDefaultAccount()
        if (response === false) {
          localStorage.clear()
          window.location.href = '/'
        } else {
          commit('setAccountContext', response)
          if (response.id) {
            this.$router.push(`/${response.id}`)
          } else {
            this.$router.push('/account/create')
          }
        }
      } catch (error) {
        this.error(error.message)
      }
    },
    init({ dispatch }) {
      return Promise.all([
        dispatch('changeAccountContext'),
      ])
    },
  },
}
